export default __webpack_public_path__ + "static/media/logo-exora.90a87baf.svg";